import styled from "styled-components";

export const WhatweDoCompWrapper = styled.div`
  .what_we_are_heading {
    margin-bottom: 30px;
  }
`;

export const CommonOverlayBoxWrapper = styled.div`
  position: relative;
  border-radius: 25px;
  overflow: hidden;
  padding: 95px 15px 119px;
  @media (max-width: 899px) {
    padding: 70px 15px;
    border-radius: 15px;
  }
  @media (max-width: 599px) {
    border-radius: 10px;
    padding: 45px 15px;
  }
  figure {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    background: rgb(4, 4, 4);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .details_text_div {
    position: relative;
    z-index: 2;
    max-width: 606px;
    margin: auto;
    text-align: center;
    * {
      color: rgb(255, 255, 255);
    }
    h3 {
      margin-bottom: 30px;
      @media (max-width: 899px) {
        margin-bottom: 20px;
      }
    }
    p {
      font-size: 24px;
      text-align: center;
      @media (max-width: 899px) {
        font-size: 16px;
      }
      @media (max-width: 599px) {
        font-size: 14px;
      }
    }
    .details_btn_Wrap {
      margin-top: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 899px) {
        margin-top: 20px;
      }
    }
  }
`;
